import React from 'react'
import { Link } from 'react-router'

function ShowUrlDisplay(record) {
  return <Link title="Show" to={`/smoke_checks/${record.id}`}>Show</Link>
}

export default ShowUrlDisplay
